import { render, staticRenderFns } from "./PackageMeisaiDialog.vue?vue&type=template&id=afe0dd46&scoped=true"
import script from "./PackageMeisaiDialog.vue?vue&type=script&lang=js"
export * from "./PackageMeisaiDialog.vue?vue&type=script&lang=js"
import style0 from "./PackageMeisaiDialog.vue?vue&type=style&index=0&id=afe0dd46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afe0dd46",
  null
  
)

export default component.exports